import { useEffect } from 'react';
import { useTranslation } from './TranslationProvider';

/**
 * Keeps `<html lang>` on the language the app is showing (PD-16672).
 *
 * index.html ships `lang="en"`, which stayed in place whatever language was
 * chosen. Browsers use `lang` to pick glyph shapes (many characters are drawn
 * differently for Traditional and Simplified Chinese readers, even at the same
 * code point), and screen readers use it to pick a voice. Mount once inside
 * the TranslationProvider of an app that owns the whole page; embedded widgets
 * must not, since the page is not theirs.
 */
export function DocumentLanguageSync(): null {
	const { currentLanguage } = useTranslation();

	useEffect(() => {
		if (currentLanguage == null || currentLanguage.trim() === '') {
			return;
		}

		document.documentElement.lang = currentLanguage;
	}, [currentLanguage]);

	return null;
}
